import { ContainerModule } from '@evertel/di'
import { VerifiedEmailDomainController } from './controller/VerifiedEmailDomainController'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(VerifiedEmailDomainController).to(VerifiedEmailDomainController)
    })
]

export { DI_MODULES }
